module.exports = __webpack_public_path__ + "img/symbol_10_x50.95a7ef31.png";